import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { FaChevronLeft, FaChevronRight, FaChevronDown, FaChevronUp } from 'react-icons/fa6';
import { useLanguage } from 'contexts/LanguageContext';
import { OrdersIcon, QuotationIcon, SalesOrderIcon, InvoiceIcon } from 'ui-component/custom-icons/icons';

// ==============================|| SIDEBAR DRAWER ||============================== //

// ✅ Clear
const Sidebar = ({ mobile, closeMobileMenu, clientLogout }) => {
	const { pathname } = useLocation();
	const [show, setShow] = useState('');
	const clientUser = useSelector((state) => state.main.client);
	const [isOpened, setIsOpened] = useState(true);
	const compRef = useRef(null);
	const [showOrdersSubmenu, setShowOrdersSubmenu] = useState(false);
	const { t } = useLanguage();

	useEffect(() => {
		setShow('');
	}, [pathname, isOpened]);

	useEffect(() => {
		if (window.innerWidth <= 1150 && isOpened) {
			setIsOpened(false);
		}
	}, []);
	const clientLogoutside = () => {
		clientLogout();
	};

	useEffect(() => {
		if (show == '' && mobile) {
			closeMobileMenu && closeMobileMenu();
		}
	}, [show, mobile]);

	const handleResize = () => {
		if (window.innerWidth <= 1150 && isOpened) {
			setIsOpened(false);
		} else if (window.innerWidth > 1150) {
			setIsOpened(true);
		}
	};

	useEffect(() => {
		window.addEventListener('resize', handleResize);

		return () => {
			window.removeEventListener('resize', handleResize);
		};
	}, []);

	const handleClickOutside = (event) => {
		if (compRef.current && !compRef.current.contains(event.target)) {
			setShow('');
		}
	};

	useEffect(() => {
		document.addEventListener('click', handleClickOutside, true);

		if (pathname.includes('/client/invoices') || pathname.includes('/client/quotations') || pathname.includes('/client/sales-orders')) {
			setShowOrdersSubmenu(true); 
		} else {
			setShowOrdersSubmenu(false);
		}
		return () => {
			document.removeEventListener('click', handleClickOutside, true);
		};
	}, [pathname]);

	return (
		<>
			{show && <div className="nav-opacity-bg">&nbsp;</div>}
			<div className={`new-nav-bar-client  ${isOpened || mobile ? 'expanded' : 'collapsed'}`}>
				<ul className="navbar-nav-items" ref={compRef}>
					<li className={`nav-item ${pathname.includes('/client/dashboard') ? 'active' : ''}`}>
						<Link
							to={'/client/dashboard'}
							className={`nav-link ${clientUser?.data?.is_approved !== 2 ? 'disabled-link' : ''}`}
							onClick={() => {
								mobile && closeMobileMenu && closeMobileMenu();
								setShowOrdersSubmenu(false);
							}}
						>
							<span className="menuIcon">
								<svg xmlns="http://www.w3.org/2000/svg" width="21.996" height="21.996" viewBox="0 0 21.996 21.996">
									<g id="stats" transform="translate(-2 -2)">
										<path
											id="Path_1941"
											data-name="Path 1941"
											d="M20.7,3.65a1.647,1.647,0,0,1,1.65,1.65V20.7a1.647,1.647,0,0,1-1.65,1.65H5.3A1.647,1.647,0,0,1,3.65,20.7V5.3A1.647,1.647,0,0,1,5.3,3.65ZM20.7,2H5.3A3.3,3.3,0,0,0,2,5.3V20.7A3.3,3.3,0,0,0,5.3,24H20.7A3.3,3.3,0,0,0,24,20.7V5.3A3.3,3.3,0,0,0,20.7,2Z"
											transform="translate(0 0)"
											fill="currentColor"
										/>
										<path
											id="Path_1942"
											data-name="Path 1942"
											d="M12.075,18.8a.831.831,0,0,1-.825-.825v-9.9a.825.825,0,0,1,1.65,0v9.9A.831.831,0,0,1,12.075,18.8Z"
											transform="translate(0.923 0.524)"
											fill="currentColor"
										/>
										<path
											id="Path_1943"
											data-name="Path 1943"
											d="M8.075,18.3a.831.831,0,0,1-.825-.825v-4.4a.825.825,0,1,1,1.65,0v4.4A.831.831,0,0,1,8.075,18.3Z"
											transform="translate(0.524 1.023)"
											fill="currentColor"
										/>
										<path
											id="Path_1944"
											data-name="Path 1944"
											d="M16.075,18.5a.831.831,0,0,1-.825-.825v-6.6a.825.825,0,0,1,1.65,0v6.6A.831.831,0,0,1,16.075,18.5Z"
											transform="translate(1.322 0.823)"
											fill="currentColor"
										/>
									</g>
								</svg>
							</span>
							<span>{t('nav.dashboard')}</span>
						</Link>
					</li>
					<li className="nav-break">&nbsp;</li>
					<li
						className={`nav-item sub-menu ${
							pathname.includes('/client/quotations') || pathname.includes('/client/sales-orders') || pathname.includes('/client/invoices')
								? 'active'
								: ''
						}`}
					>
						<a
							className={`nav-link collapsed ${clientUser?.data?.is_approved !== 2 ? 'disabled-link' : ''}`}
							href="#"
							onClick={(e) => {
								e.preventDefault();
								setShowOrdersSubmenu(!showOrdersSubmenu);
								mobile && closeMobileMenu && closeMobileMenu();
							}}
						>
							<span className="menuIcon">
								<OrdersIcon width="14px" height="14px" />
							</span>
							<span>
								{t('nav.orders')}
								<span style={{ position: 'absolute', right: '30px', marginTop: '0px' }}>
									{showOrdersSubmenu ? <FaChevronUp /> : <FaChevronDown />}
								</span>
							</span>
						</a>

						{showOrdersSubmenu && (
							<ul className={`sidebar-collapsable-menu ${showOrdersSubmenu ? 'show' : ''}`}>
								<li className={`nav-item ${pathname.includes('/client/quotations') ? 'text-active' : 'text-inactive'}`}>
									<Link
										to={'/client/quotations'}
										className={`nav-link collapsed ${clientUser?.data?.is_approved !== 2 ? 'disabled-link' : ''}`}
										style={{ marginLeft: '10px' }}
										onClick={() => mobile && closeMobileMenu && closeMobileMenu()}
									>
										<span className="menuIcon">
											<QuotationIcon height='16px' width='16px' />
										</span>
										<span className={pathname.includes('/client/quotations') ? 'text-active submenuLabel' : 'text-inactive submenuLabel'}>
											<div>{t('nav.quotations')}</div>
										</span>
									</Link>
								</li>

								{/* Sales Orders */}
								<li className={`nav-item ${pathname.includes('/client/sales-orders') ? 'text-active' : 'text-inactive'}`}>
									<Link
										to={'/client/sales-orders'}
										className={`nav-link collapsed ${clientUser?.data?.is_approved !== 2 ? 'disabled-link' : ''}`}
										style={{ marginLeft: '10px' }}
										onClick={() => mobile && closeMobileMenu && closeMobileMenu()}
									>
										<span className="menuIcon">
											<SalesOrderIcon height='16px' width='16px' />
										</span>
										<span className={pathname.includes('/client/sales-orders') ? 'text-active submenuLabel' : 'text-inactive submenuLabel'}>
											<div>{t('nav.sales-orders')}</div>
										</span>
									</Link>
								</li>

								{/* Invoices */}
								<li className={`nav-item ${pathname.includes('/client/invoices') ? 'text-active' : 'text-inactive'}`}>
									<Link
										to={'/client/invoices'}
										className={`nav-link collapsed ${clientUser?.data?.is_approved !== 2 ? 'disabled-link' : ''}`}
										style={{ marginLeft: '10px' }}
										onClick={() => mobile && closeMobileMenu && closeMobileMenu()}
									>
										<span className="menuIcon">
											<InvoiceIcon height='16px' width='16px' />
										</span>
										<span className={pathname.includes('/client/invoices') ? 'text-active submenuLabel' : 'text-inactive submenuLabel'}>
											<div>{t('nav.invoices')}</div>
										</span>
									</Link>
								</li>
							</ul>
						)}
					</li>
					<li className={`nav-item ${pathname.includes('/client/serials') ? 'active' : ''}`}>
						<Link
							to={'/client/serials'}
							className={`nav-link ${clientUser?.data?.is_approved !== 2 ? 'disabled-link' : ''}`}
							onClick={() => {
								mobile && closeMobileMenu && closeMobileMenu();
							}}
						>
							<span className="menuIcon">
								<svg viewBox="0 -42 426.66667 426" xmlns="http://www.w3.org/2000/svg" width="16" height="16">
									<path d="m74.667969.332031h-64c-5.890625 0-10.667969 4.777344-10.667969 10.667969v64c0 5.890625 4.777344 10.667969 10.667969 10.667969s10.664062-4.777344 10.664062-10.667969v-53.332031h53.335938c5.890625 0 10.664062-4.777344 10.664062-10.667969s-4.773437-10.667969-10.664062-10.667969zm0 0" fill="currentColor" />
									<path d="m74.667969 320.332031h-53.335938v-53.332031c0-5.890625-4.773437-10.667969-10.664062-10.667969s-10.667969 4.777344-10.667969 10.667969v64c0 5.890625 4.777344 10.667969 10.667969 10.667969h64c5.890625 0 10.664062-4.777344 10.664062-10.667969s-4.773437-10.667969-10.664062-10.667969zm0 0" fill="currentColor" />
									<path d="m416 .332031h-64c-5.890625 0-10.667969 4.777344-10.667969 10.667969s4.777344 10.667969 10.667969 10.667969h53.332031v53.332031c0 5.890625 4.777344 10.667969 10.667969 10.667969s10.667969-4.777344 10.667969-10.667969v-64c0-5.890625-4.777344-10.667969-10.667969-10.667969zm0 0" fill="currentColor" />
									<path d="m416 256.332031c-5.890625 0-10.667969 4.777344-10.667969 10.667969v53.332031h-53.332031c-5.890625 0-10.667969 4.777344-10.667969 10.667969s4.777344 10.667969 10.667969 10.667969h64c5.890625 0 10.667969-4.777344 10.667969-10.667969v-64c0-5.890625-4.777344-10.667969-10.667969-10.667969zm0 0" fill="currentColor" />
									<path d="m74.667969 64.332031c-5.890625 0-10.667969 4.777344-10.667969 10.667969v192c0 5.890625 4.777344 10.667969 10.667969 10.667969s10.664062-4.777344 10.664062-10.667969v-192c0-5.890625-4.773437-10.667969-10.664062-10.667969zm0 0" fill="currentColor" />
									<path d="m117.332031 64.332031h21.335938c5.890625 0 10.664062 4.777344 10.664062 10.667969v192c0 5.890625-4.773437 10.667969-10.664062 10.667969h-21.335938c-5.890625 0-10.664062-4.777344-10.664062-10.667969v-192c0-5.890625 4.773437-10.667969 10.664062-10.667969zm0 0" fill="currentColor" />
									<path d="m181.332031 64.332031c-5.890625 0-10.664062 4.777344-10.664062 10.667969v192c0 5.890625 4.773437 10.667969 10.664062 10.667969s10.667969-4.777344 10.667969-10.667969v-192c0-5.890625-4.777344-10.667969-10.667969-10.667969zm0 0" fill="currentColor" />
									<path d="m224 64.332031h21.332031c5.890625 0 10.667969 4.777344 10.667969 10.667969v192c0 5.890625-4.777344 10.667969-10.667969 10.667969h-21.332031c-5.890625 0-10.667969-4.777344-10.667969-10.667969v-192c0-5.890625 4.777344-10.667969 10.667969-10.667969zm0 0" fill="currentColor" />
									<path d="m288 64.332031c-5.890625 0-10.667969 4.777344-10.667969 10.667969v192c0 5.890625 4.777344 10.667969 10.667969 10.667969s10.667969-4.777344 10.667969-10.667969v-192c0-5.890625-4.777344-10.667969-10.667969-10.667969zm0 0" fill="currentColor" />
									<path d="m330.667969 64.332031h21.332031c5.890625 0 10.667969 4.777344 10.667969 10.667969v192c0 5.890625-4.777344 10.667969-10.667969 10.667969h-21.332031c-5.890625 0-10.667969-4.777344-10.667969-10.667969v-192c0-5.890625 4.777344-10.667969 10.667969-10.667969zm0 0" fill="currentColor" />
								</svg>
							</span>
							<span>{t('nav.serials')}</span>
						</Link>
					</li>
					<li className={`nav-item ${pathname.includes('/client/shipments') ? 'active' : ''}`}>
						<Link
							to={'/client/shipments'}
							className={`nav-link ${clientUser?.data?.is_approved !== 2 ? 'disabled-link' : ''}`}
							onClick={() => {
								mobile && closeMobileMenu && closeMobileMenu();
							}}
						>
							<span className="menuIcon">
								<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 21">
									<path
										id="plane-departure"
										d="M1.067,15.411l2.075,1.477a6.169,6.169,0,0,0,3.572,1.14,6.046,6.046,0,0,0,2.612-.59l12.953-5.7a3.012,3.012,0,0,0-2.535-5.465L16.6,7.677,9.982,3.591A3,3,0,0,0,6.93,3.28l-.781.366a2,2,0,0,0-.475,3.308l4.2,3.72-3.591,1.6L3.23,11.154A2.417,2.417,0,0,0,.5,11.945a2.312,2.312,0,0,0-.462,1.776,2.527,2.527,0,0,0,1.033,1.688ZM7,5.457l.776-.364a1.05,1.05,0,0,1,1.085.151l5.531,3.418L11.886,9.78ZM2.071,13.179a.418.418,0,0,1,.334-.169c.05,0,3.574,1.285,3.574,1.285a1,1,0,0,0,.752-.025L20.564,8.1l.013-.006A1,1,0,0,1,21.9,8.58a1.023,1.023,0,0,1-.46,1.342L8.492,15.62A4.155,4.155,0,0,1,4.3,15.258L2.226,13.782a.528.528,0,0,1-.213-.348.324.324,0,0,1,.058-.256ZM24,23a1,1,0,0,1-1,1H1a1,1,0,0,1,0-2H23A1,1,0,0,1,24,23Z"
										transform="translate(0 -3)"
										fill="currentColor"
									/>
								</svg>
							</span>
							<span>{t('nav.shipments')}</span>
						</Link>
					</li>
					{clientUser?.data?.is_approved != 2 && (
						<li
							className={`nav-item company-details-link ${
								pathname.includes('/client/company-details') ||
								pathname.includes('/client/company-address') ||
								pathname.includes('/client/company-documents') ||
								pathname.includes('/client/company-bank-details') ||
								pathname.includes('/client/company-end-details') ||
								pathname.includes('/client/company-verified')
									? 'active'
									: ''
							}`}
						>
							<Link to={'/client/company-details'} className={`nav-link `}>
								<span className="menuIcon">
									<svg xmlns="http://www.w3.org/2000/svg" width="21.996" height="21.995" viewBox="0 0 21.996 21.995">
										<path
											id="house-building"
											d="M17.414,13.747H16.5a.916.916,0,1,1,0-1.833h.917a.916.916,0,1,1,0,1.833ZM18.33,16.5a.916.916,0,0,0-.917-.916H16.5a.916.916,0,1,0,0,1.833h.917A.916.916,0,0,0,18.33,16.5Zm-3.666-11a.916.916,0,0,0-.917-.916h-.917a.916.916,0,1,0,0,1.833h.917A.916.916,0,0,0,14.664,5.5Zm3.666,0a.916.916,0,0,0-.917-.916H16.5a.916.916,0,1,0,0,1.833h.917A.916.916,0,0,0,18.33,5.5Zm0,3.666a.916.916,0,0,0-.917-.916H16.5a.916.916,0,1,0,0,1.833h.917A.916.916,0,0,0,18.33,9.165ZM22,17.413V4.582A4.588,4.588,0,0,0,17.414,0H12.831A4.588,4.588,0,0,0,8.249,4.582a.917.917,0,0,0,1.833,0,2.753,2.753,0,0,1,2.75-2.749h4.583a2.753,2.753,0,0,1,2.75,2.749V17.413a2.753,2.753,0,0,1-2.75,2.749H16.5A.916.916,0,1,0,16.5,22h.917A4.588,4.588,0,0,0,22,17.413Zm-7.332.458V14.066a4.556,4.556,0,0,0-1.759-3.609L10.156,8.3a4.576,4.576,0,0,0-5.647,0l-2.75,2.152A4.555,4.555,0,0,0,0,14.065V17.87a4.129,4.129,0,0,0,4.124,4.124H10.54a4.129,4.129,0,0,0,4.124-4.124ZM9.027,9.749l2.75,2.152a2.737,2.737,0,0,1,1.055,2.166v3.805a2.293,2.293,0,0,1-2.291,2.291H4.124a2.293,2.293,0,0,1-2.291-2.291V14.066A2.735,2.735,0,0,1,2.888,11.9l2.75-2.151a2.746,2.746,0,0,1,3.389,0ZM9.165,16.5V14.664a.917.917,0,0,0-.917-.916H6.416a.917.917,0,0,0-.917.916V16.5a.917.917,0,0,0,.917.916H8.249A.917.917,0,0,0,9.165,16.5Z"
										/>
									</svg>
								</span>

								<span>{t('nav.company-info')}</span>
							</Link>
						</li>
					)}
				</ul>

				<div className="currency-div">
					<ul className="navbar-nav-items">
						<li className={`nav-item hide-on-mobile ${pathname.includes('settings') ? 'active' : ''}`}>
							<Link className={`nav-link ${clientUser?.data?.is_approved !== 2 ? 'disabled-link' : ''}`} to={'/client/settings'}>
								<span className="menuIcon">
									<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
										<defs>
											<clipPath id="clip-path">
												<rect
													id="Rectangle_138"
													data-name="Rectangle 138"
													width="22"
													height="22"
													transform="translate(22 557)"
													stroke="#707070"
													strokeWidth="1"
												/>
											</clipPath>
										</defs>
										<g id="Mask_Group_5" data-name="Mask Group 5" transform="translate(-22 -557)" clipPath="url(#clip-path)">
											<g id="settings" transform="translate(23.102 557)">
												<path
													id="Path_202"
													data-name="Path 202"
													d="M10.666,7a3.666,3.666,0,1,0,3.666,3.666A3.666,3.666,0,0,0,10.666,7Zm0,5.5A1.833,1.833,0,1,1,12.5,10.666,1.833,1.833,0,0,1,10.666,12.5Z"
													transform="translate(-0.771 0.332)"
													fill="currentColor"
												/>
												<path
													id="Path_203"
													data-name="Path 203"
													d="M19.465,12.739l-.407-.235a8.34,8.34,0,0,0,0-3.015l.407-.235a2.751,2.751,0,1,0-2.749-4.766l-.408.236A8.227,8.227,0,0,0,13.7,3.22v-.47a2.749,2.749,0,1,0-5.5,0v.47a8.227,8.227,0,0,0-2.61,1.508l-.41-.237A2.751,2.751,0,1,0,2.429,9.256l.407.235a8.34,8.34,0,0,0,0,3.015l-.407.235a2.751,2.751,0,0,0,2.749,4.766l.408-.236a8.227,8.227,0,0,0,2.612,1.5v.47a2.749,2.749,0,1,0,5.5,0v-.47a8.227,8.227,0,0,0,2.61-1.509l.41.236a2.751,2.751,0,0,0,2.749-4.766ZM17.13,9.278a6.459,6.459,0,0,1,0,3.437.916.916,0,0,0,.425,1.038l.993.574a.917.917,0,1,1-.916,1.588l-1-.576a.916.916,0,0,0-1.114.151,6.4,6.4,0,0,1-2.972,1.718.916.916,0,0,0-.688.888v1.148a.916.916,0,1,1-1.833,0V18.1a.916.916,0,0,0-.688-.888,6.4,6.4,0,0,1-2.971-1.722.916.916,0,0,0-1.114-.151l-.993.575a.916.916,0,1,1-.916-1.587l.993-.574a.916.916,0,0,0,.425-1.038,6.459,6.459,0,0,1,0-3.437A.916.916,0,0,0,4.34,8.241l-.993-.574a.917.917,0,1,1,.916-1.588l1,.576a.916.916,0,0,0,1.113-.148A6.4,6.4,0,0,1,9.343,4.789a.916.916,0,0,0,.688-.892V2.749a.916.916,0,1,1,1.833,0V3.9a.916.916,0,0,0,.688.888,6.4,6.4,0,0,1,2.972,1.722.916.916,0,0,0,1.114.151l.993-.575a.916.916,0,1,1,.916,1.587l-.993.574a.916.916,0,0,0-.424,1.035Z"
													transform="translate(-1.052 0)"
													fill="currentColor"
												/>
											</g>
										</g>
									</svg>
								</span>
								<span>{t('nav.settings')}</span>
							</Link>
						</li>
						<li className={`nav-item hide-on-mobile ${pathname.includes('logout') ? 'active' : ''}`}>
							<a
								className="nav-link href-link-head"
								onClick={() => {
									clientLogoutside();
								}}
							>
								<span className="menuIcon">
									<svg
										id="logout_"
										data-name="logout "
										xmlns="http://www.w3.org/2000/svg"
										width="22"
										height="22"
										viewBox="0 0 21.982 20.999"
										stroke="#707070"
										strokeWidth="1"
									>
										<path
											id="logout"
											d="M4.746,21a4.708,4.708,0,0,1-4.74-4.437L0,16.342V4.657A4.7,4.7,0,0,1,4.522.005L4.746,0H9.964a4.707,4.707,0,0,1,4.741,4.437l.005.22v.98a.8.8,0,0,1-1.6.106L13.1,5.637v-.98A3.107,3.107,0,0,0,10.148,1.58l-.185-.005H4.746a3.116,3.116,0,0,0-3.135,2.9l-.005.181V16.342a3.108,3.108,0,0,0,2.956,3.076l.184,0H9.975A3.1,3.1,0,0,0,13.1,16.534l.005-.18v-.991a.8.8,0,0,1,1.6-.106l.007.106v.991a4.687,4.687,0,0,1-4.506,4.64L9.975,21Zm12.731-6.882a.776.776,0,0,1-.076-1.025L17.479,13l1.755-1.715H8.292a.787.787,0,0,1-.109-1.568l.109-.007H19.236L17.479,8a.775.775,0,0,1-.08-1.025l.077-.088A.815.815,0,0,1,18.521,6.8l.09.076,3.123,3.05a.777.777,0,0,1,0,1.141l-3.118,3.047a.814.814,0,0,1-1.135,0Z"
											fill="#17181a"
										/>
									</svg>
								</span>
								<span>{t('nav.logout')}</span>
							</a>
						</li>
					</ul>

					{!mobile && (
						<div
							className="collapse-tag"
							onClick={() => {
								setIsOpened(!isOpened);
							}}
						>
							{isOpened ? <FaChevronLeft /> : <FaChevronRight />}
						</div>
					)}
				</div>
			</div>
		</>
	);
};

export default Sidebar;
